<template>
  <div>
    <div id="canvasDiv">
      <canvas id="psCanvas"></canvas>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mainContent',
  data() {
    return {}
  },
  mounted(){
    let dom = document.getElementById('canvasDiv')
    let canvas = document.getElementById('psCanvas')
    canvas.width = dom.clientWidth
    canvas.height = dom.clientHeight
  },
  methods: {}
}
</script>

<style scoped lang='scss'>
#canvasDiv {
  height: 100%;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/editImg/mainContent.vue